import * as tavernDrinkTableData from './tables/tavern.drinks.table.json';
import { ITwoFactorTable } from "./interfaces/ITable";
import { TavernDrinkEntry } from "./models/TavernData";

const TavernDrinksTableData: ITwoFactorTable<TavernDrinkEntry> = tavernDrinkTableData as ITwoFactorTable<TavernDrinkEntry>;

export default TavernDrinksTableData;
